import { render, staticRenderFns } from "./CApprGwBtn.vue?vue&type=template&id=804c5730"
import script from "./CApprGwBtn.vue?vue&type=script&lang=js"
export * from "./CApprGwBtn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('804c5730')) {
      api.createRecord('804c5730', component.options)
    } else {
      api.reload('804c5730', component.options)
    }
    module.hot.accept("./CApprGwBtn.vue?vue&type=template&id=804c5730", function () {
      api.rerender('804c5730', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/CApprGwBtn.vue"
export default component.exports